<script lang="ts">
	import { ClipboardIcon } from "luxedo-icons"
	import { Toast } from "toaster"

	interface Props {
		textContent: string | number
	}

	let { textContent }: Props = $props()

	function copyText() {
		navigator.clipboard.writeText(String(textContent))
		Toast.success("Copied to clipboard!")
	}
</script>

<button class="copy-button only-icon small" title="Copy" onclick={copyText}>
	<ClipboardIcon />
</button>

<style>
</style>
